// 2P AI — briciole con "indietro" (← <backLabel> / <current>). Riusato da Dettaglio e Impostazioni
// (e dalle schermate di configurazione di R3).
import { Icon } from './Icon';
import { onCardKey } from '../lib/a11y';

export function Crumb({ current, onBack, backLabel = 'Progetti' }: { current: string; onBack: () => void; backLabel?: string }) {
  return (
    <div className="crumb">
      <a role="button" tabIndex={0} onClick={onBack} onKeyDown={onCardKey(onBack)}><Icon name="arrow_back" />{backLabel}</a>
      <span className="sep">/</span>
      <span className="cur">{current}</span>
    </div>
  );
}
